import { supabase } from './supabase';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function getNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    return registration;
  } catch (err) {
    console.error('Errore registrazione service worker:', err);
    return null;
  }
}

export async function subscribeToPush(userId) {
  if (!isPushSupported()) return { success: false, reason: 'unsupported' };

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return { success: false, reason: 'denied' };

  const registration = await registerServiceWorker();
  if (!registration) return { success: false, reason: 'sw_failed' };

  try {
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
    }

    const subJson = subscription.toJSON();
    const { error } = await supabase.from('push_subscriptions').upsert({
      user_id: userId,
      endpoint: subJson.endpoint,
      p256dh: subJson.keys.p256dh,
      auth: subJson.keys.auth,
    }, { onConflict: 'endpoint' });

    if (error) {
      console.error('Errore salvataggio iscrizione push:', error);
      return { success: false, reason: 'db_error' };
    }

    return { success: true };
  } catch (err) {
    console.error('Errore iscrizione push:', err);
    return { success: false, reason: 'subscribe_failed' };
  }
}

export async function initServiceWorkerSilently() {
  // Registra il service worker senza chiedere permessi (serve comunque presente per le notifiche in-app)
  if ('serviceWorker' in navigator) {
    await registerServiceWorker();
  }
}